<template>
  <div>
    <slot />
    <img
      data-cy="pref-ring-central"
      src="/images/ringcentral.svg"
      class="h-3 cursor-pointer"
      :class="{
        'opacity-70 grayscale':
          highlightedProvider !== CommunicationProvider.RingCentral,
      }"
      loading="lazy"
      @click="setPerCallProviderOverride(CommunicationProvider.RingCentral)"
    />
    <img
      v-if="allowTwilioUse"
      data-cy="pref-twilio"
      src="/images/twilio.svg"
      class="mt-0-5 h-3 cursor-pointer"
      :class="{
        'opacity-70 grayscale':
          highlightedProvider !== CommunicationProvider.Twilio,
      }"
      loading="lazy"
      @click="setPerCallProviderOverride(CommunicationProvider.Twilio)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { storeToRefs } from "pinia";

import { CommunicationProvider } from "@/enums/communicationProviders";
import { useAuth } from "@/hooks/auth";
import { useTwilio } from "@/hooks/communicationProviders";
import {
  currentPerCallProviderOverride,
  setPerCallProviderOverride,
} from "@/hooks/contacts";
import { useTwilioStore } from "@/stores/twilio";

const auth = useAuth();
const twilioStore = useTwilioStore();
const { userAssignedPhoneNumbers } = storeToRefs(twilioStore);

const { effectiveDialer } = useTwilio();

const allowTwilioUse = computed(
  () => !!userAssignedPhoneNumbers.value?.length && auth.isLendflowUser
);

const highlightedProvider = computed(
  () => currentPerCallProviderOverride.value ?? effectiveDialer.value
);
</script>
